export default __webpack_public_path__ + "static/media/permanentStation.6b719cc1.svg";